// Formats a completed run's wall-clock time from its server timestamps, e.g. "8m 42s". Null while
// either timestamp is missing (run not finished yet, or was never started).
export const formatRunDuration = (startedAt: string | null | undefined, completedAt: string | null | undefined): string | null => {
  if (!startedAt || !completedAt) return null;
  const ms = new Date(completedAt).getTime() - new Date(startedAt).getTime();
  if (!Number.isFinite(ms) || ms < 0) return null;
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
};
